// ----------------------------------------------------------------------
// <copyright file="Izenda.GridLines.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * GridLayout component
 */
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ReactDOM = require('react-dom');
  var GridCellState = require('./Izenda.GridCellState');

  var query = require('dom-helpers/query');
  var autorun = require('mobx').autorun;
  var observer = require('mobx-react').observer;
  var observablePropTypes = require('mobx-react').propTypes;

  /**
   * Component to paint grid layout lines and hover cell
   * @type {GridLines}
   */
  var GridLines = React.createClass({
    /**
     * Grid cell state
     * @type {GridCellState}
     */
    cellState: null,
    propTypes: {
      layoutStore : observablePropTypes.observableObject,
      // Allow user to insert a grid item inline
      allowAddInline: React.PropTypes.bool,
      // Function to call when user adds a grid item.
      onAddItem: React.PropTypes.func,
      transparent: React.PropTypes.bool
    },
    defaultProps : {
      transparent: false
    },
    componentWillMount : function () {
      var layoutStore = this.props.layoutStore;
      this.cellState = new GridCellState(layoutStore.cellWidth, layoutStore.cellHeight, this.props.transparent);

      this.disposeAutoRunWidth = autorun(function (){
        this.cellState.updateDimension(this.props.layoutStore.cellWidth, this.props.layoutStore.cellHeight);
      }.bind(this));

      this.disposeAutoRunTransparent = autorun(function () {
        this.cellState.setTransparent(this.props.layoutStore.transparent);
      }.bind(this));
    },
    componentDidMount: function() {
      this.listen();
    },
    componentWillUnmount: function() {
      this.unlisten();
      this.disposeAutoRunWidth();
      this.disposeAutoRunTransparent();
    },
    render: function() {
      var props = this.props;
      var layoutStore = props.layoutStore;
      var size = layoutStore.calcActualGridSize();
      var cellState = this.cellState;
      var allowAddInline = props.allowAddInline;
      var isInteracting = layoutStore.isInteracting;

      var gridLineStyle = cellState.getCellLineStyle(size.width, size.height);
      var addButtonCellStyle = cellState.getAddButtonCellStyle();

      // Only show add button when grid view allows adding inline and not be in
      // moving state and mouse hover.
      var addButtonCell = allowAddInline && !isInteracting && this.cellState.isHover
        ? (
            <div className='grid-cell' style={addButtonCellStyle}>
              <button
                  type="button"
                  className="btn AddItemButton"
                  onClick={this.onAddItem} >
                <span className="icon-plus" />
              </button>
            </div>
          )
        : null;

      return (
        <div ref='gridLines' className='GridLine' style={gridLineStyle}>
          {props.children}
          {addButtonCell}
        </div>
      );
    },
    /**
     * Register the component DOM's event handlers.
     */
    listen: function (){
      var node = this.refs.gridLines;
      if (this.props.allowAddInline){
        node.addEventListener("mousemove", this.onMouseMove, false);
        node.addEventListener("mouseleave", this.onMouseLeave, false);
      }
    },
    /**
     * Unregister the component DOM's event handlers
     */
    unlisten: function () {
      var node = this.refs.gridLines;
      if (this.props.allowAddInline){
        node.removeEventListener("mousemove", this.onMouseMove,false);
        node.removeEventListener("mouseleave", this.onMouseLeave, false);
      }
    },
    /**
     * Handle mouse move event to update the hover cell state
     */
    onMouseMove: function(e) {
      if (!this.props.isMoving) {
        var offset = query.offset(this.refs.gridLines);
        var x = e.pageX - offset.left;
        var y = e.pageY - offset.top;
        if(!this.cellState.isCurrentCell(x, y)){
          this.cellState.onPosition(x, y, true /*is hover*/);
        }
      }
    },
    /**
     * Handle mouse leave event to update the hover cell state
     */
    onMouseLeave: function(e) {
      if (!this.props.isMoving) {
        this.cellState.resetPosition();
      }
    },
    /**
     * Call adding grid item
     */
    onAddItem: function() {
      var props = this.props;
      var cellPos = this.cellState.getHoverCellPosition();

      var spare = props.layoutStore.addItemAt(cellPos.x, cellPos.y);

      props.onAddItem && props.onAddItem(spare);
    }
  });

  module.exports = observer(GridLines);
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridLines.jsx